import { AxiosError } from 'axios'
import { computed, flow, makeObservable, observable } from 'mobx'

import { requestWrapper } from 'Shared/utils'
import { openDocumentFromBuffer } from 'Shared/utils/file'

import { STORE_UI } from 'Core/constants/stores'
import { CustomGenerator } from 'Core/interfaces'
import { getDefaultStoreArrayValue } from 'Core/utils'

import { TreatmentMethod } from 'Portals/Customer/entities'
import { TreatmentMethodRepo } from 'Portals/Customer/repositories'
import { RootStore } from 'Portals/Customer/stores'

import { TreatmentMethodTable } from './TreatmentMethodTable'

export class TreatmentMethodStore {
	table: TreatmentMethodTable
	rootStore: RootStore
	@observable accessor treatmentMethodsMostUsed = getDefaultStoreArrayValue<TreatmentMethod.MostUsed>()
	@observable accessor isOverviewDocumentDownloading: boolean = false

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore
		this.table = new TreatmentMethodTable(rootStore)
	}

	@flow.bound
	*retrieveTreatmentMethodsMostUsed(): CustomGenerator<TreatmentMethod.MostUsed[]> {
		yield requestWrapper({
			field: this.treatmentMethodsMostUsed,
			repository: TreatmentMethodRepo.retrieveTreatmentMethodsMostUsed,
			repositoryParams: null
		})
	}

	@computed
	get formattedTreatmentMethodsMostUsed() {
		return this.treatmentMethodsMostUsed.value.map((item) => ({
			value: item.sharePercentage,
			label: `${item.treatmentMethodName} (${item.sharePercentage}%)`
		}))
	}

	@flow.bound
	*downloadOverviewDocument(): CustomGenerator<ArrayBuffer> {
		this.isOverviewDocumentDownloading = true

		try {
			const document = yield TreatmentMethodRepo.downloadOverviewDocument()
			openDocumentFromBuffer(document)
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification(error as AxiosError)
		} finally {
			this.isOverviewDocumentDownloading = false
		}
	}
}
